import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { HealthRecord } from "../../../../../apis/stats/rest/models";
import { ReadableSizePipe } from "../../../../../helpers/bitspipe/bitspipe";

@Component({
  selector: "traffic-speed",
  templateUrl: "traffic-speed.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class TrafficSpeedComponent {
  showTraffic = input.required<boolean>();
  health = input.required<HealthRecord>();

  traffic = computed(() => {
    if (!this.showTraffic()) {
      return null;
    }
    // The lines are needed to format the speed and unit in different ways (instead of using a pipe in the html)

    const bitsPipe = new ReadableSizePipe();

    const formatSpeed = (speed: string) => {
      const [value, unit = ""] = speed.split(" ");
      return { speed: value, unit };
    };

    const up = bitsPipe.transform(this.health().out);
    const down = bitsPipe.transform(this.health().in);

    return {
      up: formatSpeed(up),
      down: formatSpeed(down),
    };
  });
}
